import React, { useContext } from "react";
import { gql } from "apollo-boost";
import { connect, useSelector } from "react-redux";
import { compose } from "redux";
import { MobileContext, withQuery } from "components/common";
import InviteFriends from "./InviteFriends";
import ReferralLink from "./ReferralLink";
import SuccessfulReferrals from "./SuccessfulReferrals";
import CurrentCashback from "./CurrentCashback";
import ReferralsTable from "./ReferralsTable";
import { track } from "../../../utils/analytics";

const Referrals = ({ roles, data: { user } }) => {
  const numSuccessfulReferrals = (user.promotions || []).filter(
    (r) => r.type == "0.01",
  ).length;
  const currentCashback = user.cashback_percentage || 0;

  const referrals =
    (user.promotions || []).length > 0 ? user.promotions.slice(0) : [];
  referrals.push(
    ...(user.referrals || [])
      .filter((ref) => ref.status === "pending")
      .map((ref) => ({
        status: ref.status,
        name: ref.recipient,
        started_at: null,
        ended_at: null,
      })),
  );
  console.log(referrals);
  track("DASHBOARD_REFERRALS_PAGE_LOADED");

  const { isMobile } = useContext(MobileContext);
  const padding = isMobile ? 16 : 28;

  return (
    <>
      {/* <ReferralSub className="mb-3" /> */}
      <div className="flex flex-col md:flex-row-reverse md:-mx-2">
        <div className="px-2 flex flex-col mb-3 md:w-1/2 md:mb-0">
          <ReferralLink className="mb-3 flex-1" user={user} />
          <CurrentCashback
            className="mb-3 flex-1"
            number={currentCashback}
            padding={padding}
          />
          <SuccessfulReferrals
            className="flex-1"
            number={numSuccessfulReferrals}
            padding={padding}
          />
        </div>
        <InviteFriends className="px-2 md:w-1/2" />
      </div>
      <ReferralsTable className="" referrals={referrals} />
    </>
  );
};

const USER_QUERY = gql`
  query UserReferrals {
    user {
      type
      referral_code
      cashback_percentage
      rewards {
        available_points
        pending_points
      }
      referrals {
        status
        recipient
        sender
      }
      promotions {
        status
        type
        name
        started_at
        ended_at
      }
    }
  }
`;

export default compose(
  connect((state) => ({
    roles: state.user.roles,
  })),
  withQuery(USER_QUERY),
)(Referrals);
